export default function addToHistory() {
  const { map } = this;
  const { onAddToHistory } = this.props;
  return new Promise(resolve => {
    return map.data.toGeoJson(obj => {
      onAddToHistory(obj);
      return resolve(obj);
    });
  });
}



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/Map/methods/handleHistory.js